import { useContext, useState } from "react";
import { Box, Button, Modal, Typography } from "@mui/material";
import VerificationInput from "react-verification-input";
import axios from "axios";
import { AppContext } from "../../scripts/context/App";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

export default function TowFAComponent({
  setTwoFA,
  twoFA,
  userInformation,
  setUserInformation,
}: any) {
  const navigate = useNavigate();
  const { setState } = useContext(AppContext);
  const [loading, setLoading] = useState(false);
  const handleClose = () => setTwoFA(false);

  const style = {
    position: "absolute" as "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "92%",
    maxWidth: 500,
    height: 300,
    bgcolor: "background.paper",
    borderRadius: "24px",
    boxShadow: 24,
    display: "flex",
    flexDirection: "column",
  };

  const handelSubmit = async () => {
    setLoading(true);
    try {
      const { data } = await axios.post("/2fa/check", userInformation);
      localStorage.setItem("token", data.token);
      axios.defaults.headers.common["Authorization"] = data.token.includes(
        "Bearer"
      )
        ? data.token
        : `Bearer ${data.token}`;

      const roles_and_permissions = await Promise.all([
        data.user.permissions.includes("view_system_role") ? axios.get("/roles/get-roles", {
          params: { getAll: 1 },
        }) : Promise.resolve({ data: [] }),
        axios.get("/roles/get-permissions"),
      ]);

      setState({
        user: {
          ...data.user,
          two_fa: data.two_fa
        },
        roles_permissions: roles_and_permissions[0]?.data || [],
        permissions: roles_and_permissions[1]?.data.data || [],
      });

      setLoading(false);
      navigate("/dashboard");
      handleClose();
    } catch (error: any) {
      setUserInformation({
        ...userInformation,
        one_time_password: "",
      })
      toast.error(
        error.response?.data?.message || "Something went wrong, please try again"
      )
      console.log(error);
      setLoading(false);
    }
  };

  return (
    <Modal
      keepMounted
      open={twoFA}
      onClose={handleClose}
      aria-labelledby="google-authentication-code"
    >
      <Box sx={style}>
        <Box sx={{ p: 3, borderBottom: "1px solid #d3d3d3" }}>
          <Typography variant="h6" component="h2" sx={{ fontWeight: "bold" }}>
            Welcome
          </Typography>
          <Typography color="#696969">
            Enter Your Google Authentication Code.
          </Typography>
        </Box>
        <Box
          sx={{
            flex: 1,
            maxWidth: 340,
            paddingTop: 1,
            alignSelf: "center",
            width: "100%",
          }}
        >
          <VerificationInput
            length={6}
            onChange={(value) => {
              if (loading) return;

              const code = value.replace(/[^0-9]/g, "");                  
              setUserInformation({
                ...userInformation,
                one_time_password: code,
              });
            }}
            value={userInformation.one_time_password}
            placeholder="."
            autoFocus
            inputProps={{
              autoFocus: true,
            }}
          />
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "0.5rem",
            p: 3,
            borderTop: "1px solid #d3d3d3",
          }}
        >
          <Button variant="contained" onClick={handelSubmit} disabled={loading}>
            Confirm
          </Button>
          <Button
            variant="outlined"
            onClick={() => setTwoFA(false)}
            disabled={loading}
          >
            Cancel
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}
